import React from "react";

class Impressum extends React.Component {

  componentDidMount() {

  }

  render() {
    return (
      <div key='impressum' class='contentcontainer'>
        <h2 class='contentheader'>Impressum</h2>
        <div class='content-thin' >
          <b>Augenstern e.K.</b><br /><br /><br />
          <b>Inhaberin:</b><br />
          Alexandra Gabriele Faltermeier<br />
          HRA 11265<br />
          USt.-IdNr. DE316020303<br /><br />
          Inhaltlich Verantwortliche gemäß § 6 MDSTV:<br /><br />
          Am Kreutfeld 18<br />
          93104 Sünching<br />
          Deutschland<br /><br />
          Telefon: + 49 (0) 151 111 988 97<br />
          E-Mail: info@augenstern-schmuck.de<br />
          Homepage: www.augenstern-schmuck.de
          <br /><br />
        </div>
      </div >
    );
  }
}

export default (Impressum);
